module.exports = __webpack_public_path__ + "static/media/about4.512da132.jpg";